"use client";
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useInteractionStart from "@/hooks/useInteractionStart";

const FooterPaymentMethods = () => {
  const company = useGetCompanyQuery();
  const t = useTranslation();
  const payment_methods = company.data?.result?.payment_methods;
  const { isInteracting } = useInteractionStart();
  if (payment_methods?.length === 0 || !isInteracting) return null;
  return (
    <Row style={{ gap: 12, margin: "0 0 24px 0" }}>
      <div className="footer-title p-0">{t?.payment_methods}</div>
      {payment_methods?.map(
        (p, key) =>
          p.icon && (
            <Col key={key} className="p-0 col-auto">
              <img
                alt={p.name.substring(0, 3)}
                src={p.icon}
                width={"auto"}
                height={20}
                style={{ objectFit: "contain" }}
              />
            </Col>
          ),
      )}
    </Row>
  );
};

export default FooterPaymentMethods;
